export default __webpack_public_path__ + "static/media/blog-03.44533b0e.jpg";